import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  Button,
  useColorModeValue,
} from '@chakra-ui/react';
import { ArrowBackIcon } from '@chakra-ui/icons';

interface PrivacyPolicyProps {
  onBack?: () => void;
}

const PrivacyPolicy: React.FC<PrivacyPolicyProps> = ({ onBack }) => {
  const bgColor = useColorModeValue('white', 'gray.800');
  const textColor = useColorModeValue('gray.700', 'gray.200');
  const headingColor = useColorModeValue('gray.800', 'white');

  return (
    <Container maxW="container.lg" py={8}>
      {onBack && (
        <Button
          leftIcon={<ArrowBackIcon />}
          onClick={onBack}
          mb={4}
          variant="ghost"
          size="sm"
        >
          戻る
        </Button>
      )}
      <Box bg={bgColor} p={8} borderRadius="lg" shadow="md">
        <VStack spacing={6} align="stretch">
          <Heading as="h1" size="xl" color={headingColor} textAlign="center">
            プライバシーポリシー
          </Heading>
          
          <Text color={textColor} fontSize="sm" textAlign="right">
            最終更新日：2025年6月9日
          </Text>

          <VStack spacing={4} align="stretch">
            <Box>
              <Heading as="h2" size="md" color={headingColor} mb={3}>
                1. 基本方針
              </Heading>
              <Text color={textColor} lineHeight="1.7">
                from-garage（以下「当社」）は、ReLoop（以下「本サービス」）をご利用いただくユーザーの個人情報の保護を重要な責務と考え、個人情報保護法および関連法令を遵守し、適切な取り扱いを行います。
              </Text>
            </Box>

            <Box>
              <Heading as="h2" size="md" color={headingColor} mb={3}>
                2. 収集する情報
              </Heading>
              <VStack spacing={2} align="stretch">
                <Text color={textColor} lineHeight="1.7">
                  <strong>2.1 入力データ</strong><br />
                  文章リライト機能で入力されたテキストデータ
                </Text>
                <Text color={textColor} lineHeight="1.7">
                  <strong>2.2 利用状況データ</strong><br />
                  API使用回数、機能利用履歴、アクセスログ
                </Text>
                <Text color={textColor} lineHeight="1.7">
                  <strong>2.3 技術情報</strong><br />
                  IPアドレス、ブラウザ情報、デバイス情報
                </Text>
              </VStack>
            </Box>

            <Box>
              <Heading as="h2" size="md" color={headingColor} mb={3}>
                3. 情報の利用目的
              </Heading>
              <VStack spacing={2} align="stretch">
                <Text color={textColor} lineHeight="1.7">
                  • 本サービスの提供および運営<br />
                  • サービス品質の向上および新機能の開発<br />
                  • 利用状況の分析およびパフォーマンス改善<br />
                  • 技術的問題の解決およびサポート提供
                </Text>
              </VStack>
            </Box>

            <Box>
              <Heading as="h2" size="md" color={headingColor} mb={3}>
                4. 第三者提供
              </Heading>
              <Text color={textColor} lineHeight="1.7">
                当社は、法令に基づく場合を除き、ユーザーの同意なく個人情報を第三者に提供することはありません。ただし、以下の外部サービスを利用しており、それぞれのプライバシーポリシーが適用されます：
              </Text>
              <VStack spacing={1} align="stretch" ml={4}>
                <Text color={textColor} lineHeight="1.7">
                  • Google Gemini API（AI文章生成）<br />
                  • Cloudflare Pages（ホスティング）
                </Text>
              </VStack>
            </Box>

            <Box>
              <Heading as="h2" size="md" color={headingColor} mb={3}>
                5. データの保存期間
              </Heading>
              <Text color={textColor} lineHeight="1.7">
                入力されたテキストデータは処理後速やかに削除され、永続的に保存されることはありません。利用状況データは統計分析の目的で匿名化処理の上、最大1年間保存される場合があります。
              </Text>
            </Box>

            <Box>
              <Heading as="h2" size="md" color={headingColor} mb={3}>
                6. セキュリティ
              </Heading>
              <Text color={textColor} lineHeight="1.7">
                当社は、個人情報への不正アクセス、紛失、破壊、改ざんおよび漏洩等を防止するため、適切なセキュリティ対策を実施しています。
              </Text>
            </Box>

            <Box>
              <Heading as="h2" size="md" color={headingColor} mb={3}>
                7. プライバシーポリシーの変更
              </Heading>
              <Text color={textColor} lineHeight="1.7">
                本プライバシーポリシーは、法令の変更やサービスの改善に伴い変更される場合があります。重要な変更については、本サービス上で事前に通知いたします。
              </Text>
            </Box>

            <Box>
              <Heading as="h2" size="md" color={headingColor} mb={3}>
                8. お問い合わせ
              </Heading>
              <Text color={textColor} lineHeight="1.7">
                本プライバシーポリシーに関するご質問やご意見は、お問い合わせページからご連絡ください。
              </Text>
            </Box>
          </VStack>
        </VStack>
      </Box>
    </Container>
  );
};

export default PrivacyPolicy;